const fields = {
	trafficSource: ['moe_source', 'utm_source'],
	trafficMedium: ['moe_source_medium', 'utm_medium'],
	trafficCampaignName: ['moe_source_campaign_name', 'utm_campaign'],
	trafficCampaignId: ['moe_source_campaign_id', 'utm_id'],
} as const;

// Current-event attribution only: do not invent MoEngage session/last-touch semantics.
export function eventContext(
	name?: string,
	attributes: Record<string, unknown> = {},
) {
	let query = new URLSearchParams();
	try {
		query = new URLSearchParams(window.location.search);
	} catch {
		/* SSR */
	}
	const context: Record<string, string> = { legacyAppName: 'FarMart' };
	if (name) context.legacyEventName = name;
	for (const [target, [vendor, utm]] of Object.entries(fields)) {
		const value = attributes[vendor] ?? attributes[utm] ?? query.get(utm);
		if (typeof value === 'string' && value.length > 0 && value.length <= 512)
			context[target] = value;
	}
	return context;
}

export function legacyEventAttributes(
	attributes: Record<string, unknown>,
	osVersion?: string,
) {
	const context = eventContext(undefined, attributes);
	return {
		...attributes,
		...(osVersion ? { os_version: osVersion } : {}),
		...(context.trafficSource ? { moe_source: context.trafficSource } : {}),
		...(context.trafficMedium
			? { moe_source_medium: context.trafficMedium }
			: {}),
		...(context.trafficCampaignName
			? { moe_source_campaign_name: context.trafficCampaignName }
			: {}),
		...(context.trafficCampaignId
			? { moe_source_campaign_id: context.trafficCampaignId }
			: {}),
	};
}
